import type { CaptureResult, PostHogConfig } from 'posthog-js';
import { getPostHogConfig } from './posthog-config';
import { containsVaultTelemetryURL, vaultTelemetryBlocked } from '@/lib/vault-telemetry';

export function isOAuthTelemetryPath(pathname: string): boolean {
  return pathname.startsWith('/oauth/');
}

function pathnameFromURL(value: string): string | null {
  try {
    return new URL(value).pathname;
  } catch {
    return null;
  }
}

export function suppressOAuthTelemetry(capture: CaptureResult | null): CaptureResult | null {
  if (!capture || vaultTelemetryBlocked() || containsVaultTelemetryURL(capture.properties))
    return null;

  const currentUrl = capture.properties.$current_url;
  if (typeof currentUrl === 'string') {
    const pathname = pathnameFromURL(currentUrl);
    if (pathname && isOAuthTelemetryPath(pathname)) return null;
  }

  const pathname = capture.properties.$pathname?.toString();
  return pathname && isOAuthTelemetryPath(pathname) ? null : capture;
}

export function getPostHogBrowserOptions(): Partial<PostHogConfig> {
  const { uiHost } = getPostHogConfig();

  return {
    api_host: '/relay-kernel',
    ui_host: uiHost,
    person_profiles: 'identified_only',
    autocapture: {
      dom_event_allowlist: ['click', 'change', 'submit'],
      capture_copied_text: false,
    },
    capture_performance: true,
    capture_exceptions: true,
    capture_pageview: false,
    capture_pageleave: false,
    cookieless_mode: 'on_reject',
    disable_session_recording: true,
    session_recording: { blockSelector: '[data-vault-sensitive], .ph-sensitive' },
    opt_out_capturing_by_default: true,
    before_send: suppressOAuthTelemetry,
  };
}
